import React, { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import WhatsAppFloat from "../components/site/WhatsAppFloat";
import { useSite } from "../context/SiteContext";

export default function PageLayout({ children, testId = "page", pageTitle }) {
    const { content } = useSite();
    const seo = content.seo || {};

    useEffect(() => {
        const base = seo.title || "KA Academy";
        document.title = pageTitle ? `${pageTitle} — ${base}` : base;
        // description
        let meta = document.querySelector('meta[name="description"]');
        if (!meta) {
            meta = document.createElement("meta");
            meta.setAttribute("name", "description");
            document.head.appendChild(meta);
        }
        meta.setAttribute("content", seo.description || "");
        // keywords
        let kw = document.querySelector('meta[name="keywords"]');
        if (!kw) {
            kw = document.createElement("meta");
            kw.setAttribute("name", "keywords");
            document.head.appendChild(kw);
        }
        kw.setAttribute("content", seo.keywords || "");
    }, [pageTitle, seo.title, seo.description, seo.keywords]);

    return (
        <div data-testid={testId} className="min-h-screen bg-white flex flex-col">
            <Header />
            <main className="flex-1">{children}</main>
            <Footer />
            <WhatsAppFloat />
        </div>
    );
}
